<template>
    <transition name="confirm-fade">
        <div v-if="isShowConfirm" class="my-confirm" @click.stop="clickFun('clickCancel')">
            <div class="wrap ub ub-ac ub-pc" :style="{'height':con_h, 'line-height':con_h}">
                <img :src="content" class="full-img" />
            </div>
        </div>
    </transition>
</template>

<script>

    export default {
        data() {
            return {
                isShowConfirm: false, // 用于控制整个窗口的显示/隐藏
                content: 'pic_url', // 内容框的内容
                con_h: '20em'
            }
        },

        methods: {
            show(url) {
                this.content = url;
                this.isShowConfirm = true;

                //调整图片位置
                var h1 = window.innerHeight;
                this.con_h = h1 + 'px';
            },
            hidden() {
                this.isShowConfirm = false
                this.outerData = null
            },
            clickFun(type) {
                this.hidden()
            }
        }
    }
</script>

<style scoped>
    .my-confirm {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.9);
        z-index: 998;
        /* 这里防止当用户长按屏幕，出现的黑色背景色块，以及 iPhone 横平时字体的缩放问题 */
        -webkit-text-size-adjust: 100%;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    }

    /* 进入和出去的动画 */
    .confirm-fade-enter-active {
        animation: opacity 0.3s;
    }

    .confirm-fade-enter-active .wrap {
        animation: scale 0.3s;
    }

    .confirm-fade-leave-active {
        animation: outOpacity 0.2s;
    }
        /* 进来的动画 */
        @keyframes opacity {
        0% {
            opacity: 0;
        }

        100% {
            opacity: 1;
        }
    }

    @keyframes scale {
        0% {
            transform: scale(0);
        }

        60% {
            transform: scale(1.1);
        }

        100% {
            transform: scale(1);
        }
    }

    /* 出去的动画 */
    @keyframes outOpacity {
        0% {
            opacity: 1;
        }

        100% {
            opacity: 0;
        }
    }

    /* 包裹层容器样式 */
    .wrap {
        position: absolute;
        top:0;
        width: 100%;
        margin: 0 auto;
        z-index: 999;
        user-select: none;
        text-align: center;
    }

    .full-img {
        width: auto;
        max-width: 99%;
        max-height: 99%;
    }
</style>